import React from "react";
import { useParams } from "react-router-dom";
import { LibraryModuleForm } from "@/modules/learningCenter/features/ModuleLibrary/components/LibraryModuleForm/LibraryModuleForm";
import { useEditLibraryModule } from "@/modules/learningCenter/features/ModuleLibrary/hooks/useEditLibraryModule/useEditLibraryModule";

const EditLibraryModule: React.FC = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const {
    form,
    module,
    loading,
    error,
    isSubmitting,
    submitForm,
    handleCancel,
    handlePublish,
    handleArchive,
  } = useEditLibraryModule(uuid ?? "");

  return (
    <LibraryModuleForm
      error={error}
      form={form}
      isSubmitting={isSubmitting}
      loading={loading}
      mode="edit"
      module={module}
      onArchive={handleArchive}
      onCancel={handleCancel}
      onPublish={handlePublish}
      onSubmit={submitForm}
    />
  );
};

export default EditLibraryModule;
